import { __decorate, __extends } from "tslib";
import { injectable } from 'tsyringe';
import { BasketPlugin, } from '../../models';
var BasketExceptionHandlerPlugin = /** @class */ (function (_super) {
    __extends(BasketExceptionHandlerPlugin, _super);
    function BasketExceptionHandlerPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleError = function (exception) {
            if (!exception) {
                return;
            }
            switch (exception.type) {
                case "InvalidCustomerException" /* BasketExceptionType.InvalidCustomerException */:
                case "BasketNotFoundException" /* BasketExceptionType.BasketNotFoundException */:
                    // In case something went wrong during basket CRUD operation.
                    _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, {});
                    break;
                case "InvalidProductItemIdException" /* BasketExceptionType.InvalidProductItemIdException */:
                    _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, {});
                    break;
                case "HookInternalServerErrorException" /* BasketExceptionType.HookInternalServerErrorException */:
                    // In case hook on backend side is broken. In that case basket can not be created.
                    _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, {});
                    break;
                case "TypeDecodingException" /* BasketExceptionType.TypeDecodingException */:
                    _this.eventBus.post("push-message" /* BasketEvent.PushMessage */, { text: exception.message });
                    break;
                default:
                    break;
            }
        };
        return _this;
    }
    BasketExceptionHandlerPlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus;
        this.eventBus = eventBus;
        this.eventBus.subscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.handleError);
    };
    BasketExceptionHandlerPlugin.prototype.shouldRegister = function () {
        return true;
    };
    BasketExceptionHandlerPlugin.prototype.unregister = function () {
        this.eventBus.unsubscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.handleError);
    };
    BasketExceptionHandlerPlugin = __decorate([
        injectable()
    ], BasketExceptionHandlerPlugin);
    return BasketExceptionHandlerPlugin;
}(BasketPlugin));
export { BasketExceptionHandlerPlugin };
